import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface IModal {
  id: string
  source?: string
}

export enum SavedStatesDetailsSource {
  SNACKBAR = 'snackbar',
  CARD = 'card'
}

const initialState: Array<IModal> = []

// TODO: use a generic action, and toggle modals by id; code duplication
const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    openLocalFilterModal(state, action: PayloadAction) {
      const modalOpened = state.find((modal) => modal.id === action.type)

      return modalOpened ? state : state.concat({ id: action.type })
    },

    openSystemScopeModal(state, action: PayloadAction) {
      const modalOpened = state.find((modal) => modal.id === action.type)

      return modalOpened ? state : state.concat({ id: action.type })
    },

    openWisDetailsModal(state, action: PayloadAction) {
      const modalOpened = state.find((modal) => modal.id === action.type)

      return modalOpened ? state : state.concat({ id: action.type })
    },

    /*
    TODO: Handle closeModal by filtering out the modal
    This logic won't handle multiple open modals correctly. It will
    close the last open one. It should filter out the clicked modal instead.
     */
    closeModal(state) {
      return state.slice(0, -1)
    }
  }
})

export default modalsSlice.reducer

export const {
  openLocalFilterModal,
  openSystemScopeModal,
  openWisDetailsModal,
  closeModal
} = modalsSlice.actions
